// extracted by mini-css-extract-plugin
export default {"root":"SqKdBiRIL1kaPZM4nq_t","isGreyedOut":"vBXJxqDcp7mkg0OShLnG"};